import { render, staticRenderFns } from "./imagesEditor.vue?vue&type=template&id=d89bc4c8&"
import script from "./imagesEditor.vue?vue&type=script&lang=js&"
export * from "./imagesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports